export default __webpack_public_path__ + "static/media/review19.a6dd2cfd.jpg";